import { render, staticRenderFns } from "./CheckPlanBaseTable.vue?vue&type=template&id=4543703a"
import script from "./CheckPlanBaseTable.vue?vue&type=script&lang=js"
export * from "./CheckPlanBaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports